import React from 'react';
import Layout from '@/components/layout/Layout';
import HeroSection from '@/components/home/HeroSection';
import ServicesSection from '@/components/home/ServicesSection';
import ProjectsSection from '@/components/home/ProjectsSection';
import StatsSection from '@/components/home/StatsSection';
import AboutSection from '@/components/home/AboutSection';
import NewsSection from '@/components/home/NewsSection';
import AwardsSection from '@/components/home/AwardsSection';
import TestimonialsSection from '@/components/home/TestimonialsSection';
import CareersSection from '@/components/home/CareersSection';
import LocationsSection from '@/components/home/LocationsSection';
import CTASection from '@/components/home/CTASection';
import SEOHead, { getOrganizationSchema, getLocalBusinessSchema, getWebsiteSchema } from '@/components/shared/SEOHead';

const HomePage = () => {
  return (
    <Layout>
      <SEOHead
        title="Civil Engineering & Infrastructure Specialists"
        description="Redspire Civil Engineering delivers transportation, water, and structural infrastructure programs with integrated design, construction management, and digital delivery teams."
        canonical="https://redspire.com/"
        schema={[getOrganizationSchema(), getLocalBusinessSchema(), getWebsiteSchema()]}
      />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <ProjectsSection />
      <StatsSection />
      <NewsSection limit={3} />
      <AwardsSection />
      <TestimonialsSection />
      <LocationsSection />
      <CareersSection />
      <CTASection />
    </Layout>
  );
};

export default HomePage;
